import { EStatusMatches } from '@/app/pages/sports/football/enums';
import { TranslationService } from '@/app/services/translation.service';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { MatchSummary } from '../models';

@Component({
  selector: 'app-match-details',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './match-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatchDetailsComponent {
  urlImg = environment.urlIMG;
  urlIcon = environment.urlIcon;

  translateService = inject(TranslationService);

  data = input.required<MatchSummary>();

  getCalendarIcon() {
    return this.urlIcon + 'calendar-white.svg';
  }

  getHomeTeamImage() {
    return this.data().HomeTeam?.ImageUrl || this.urlImg + 'default.png';
  }

  getAwayTeamImage() {
    return this.data().AwayTeam?.ImageUrl || this.urlImg + 'default.png';
  }

  getHomeTeamName() {
    return this.translateService.getTraduccionName(
      this.data().HomeTeam?.NameTranslation,
      this.data().HomeTeam?.Name || 'NA'
    );
  }

  getAwayTeamName() {
    return this.translateService.getTraduccionName(
      this.data().AwayTeam?.NameTranslation,
      this.data().AwayTeam?.Name || 'NA'
    );
  }

  isLiveGame() {
    return this.data().State === EStatusMatches.NORMAL;
  }

  getHomeScore() {
    return this.data().HomeTeam?.Scores.FinalScore || 0;
  }

  getAwayScore() {
    return this.data().AwayTeam?.Scores.FinalScore || 0;
  }

  getMatchTag() {
    if (this.data().State === EStatusMatches.NORMAL) {
      return this.data().MatchGamePeriod;
    }

    return this.data().State;
  }

  getMatchDate() {
    const date = new Date(this.data().MatchStart);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    if (this.data().State === EStatusMatches.NORMAL) {
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    }

    return `${day}.${month}.${year}`;
  }

  getHomeTeamRedirectionUrl() {
    return this.translateService.getTraslateUrlTeamDetails(
      {
        en: this.data().HomeTeam?.NameTranslation?.['en'],
        es: this.data().HomeTeam?.NameTranslation?.['es'],
      },
      this.data().HomeTeam?.Name ?? '',
      this.data().HomeTeam?.Id ?? ''
    );
  }

  getAwayTeamRedirectionUrl() {
    return this.translateService.getTraslateUrlTeamDetails(
      {
        en: this.data().AwayTeam?.NameTranslation?.['en'],
        es: this.data().AwayTeam?.NameTranslation?.['es'],
      },
      this.data().AwayTeam?.Name ?? '',
      this.data().AwayTeam?.Id ?? ''
    );
  }
}
